<template>
    <div class="form-container">
        <h3 v-if="form.category == 'quiz' || form.category == 'feedback' || form.category == 'document'" class="form-container__title">
            <b>{{ form.name }}</b>
        
            <span v-if="form.category == 'quiz' || form.category == 'feedback' || form.category == 'document'">
                <span v-if="form.category == 'quiz'" class="btn btn-sm badge-counter badge-counter-large" :class="this.deadlineDay < 0 ? 'badge-counter-warning' : ''">
                    <app-icon :name="'check-square'" width="16" height="16"/> <b> {{ $t("fill_form")}} {{ this.$t("tasks_to_be_done_before") }}{{ this.deadlineTo ? this.deadlineTo : this.deadlineFrom }}</b>
                </span>
                <span v-else-if="form.category == 'feedback'" class="btn btn-sm badge-counter badge-counter-large" :class="this.deadlineDay < 0 ? 'badge-counter-warning' : ''">
                    <app-icon :name="'message-circle'" width="16" height="16"/> <b> {{ $t("fill_form")}} {{ this.$t("tasks_to_be_done_before") }}{{ this.deadlineTo ? this.deadlineTo : this.deadlineFrom }}</b>
                </span>
                <span v-else-if="form.category == 'document'" class="btn btn-sm badge-counter badge-counter-large" :class="this.deadlineDay < 0 ? 'badge-counter-warning' : ''">
                    <app-icon :name="'edit-3'" width="16" height="16"/> <b> {{ $t(form.document_type) }} {{ this.$t("tasks_to_be_done_before") }}{{ this.deadlineTo ? this.deadlineTo : this.deadlineFrom }}</b>
                </span>
            </span>
        </h3>
        

        <div v-if="form.category == 'quiz' || form.category == 'feedback' || form.category == 'document'" class="body-container form-employee-container">
            <div v-if="form.completed">
                <div class="note note-info note-result w-100 mt-2 mb-3 text-left row">
                    <div class="col-sm-2 col-md-3 d-none d-md-block">
                        <img src="/images/illustration_done.svg" />
                    </div>
                    <div class="col-sm-12 col-md-9 form-employee-result">
                        <b>
                            {{ $t("welldone_" + form.category + "_completed") }}
                        </b>
                    </div>

                    <div class="confetti">
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                        <div class="confetti-piece"></div>
                    </div>
                </div>
            </div>
            <div v-if="form.document_content && form.document_type != 'sign_uploaded_document'" class="document-preview">
                <div v-html="documentContent"></div>
                <app-icon :name="'file'" width="22" height="22" class="document-preview-icon"/>
            </div>
            <div v-else-if="form.document_type == 'sign_uploaded_document'" class="document-preview text-center">
                <!-- @todo: URL doplnit -->
                <a href="#"
                    target="_blank"
                    class="btn btn-primary btn-pulse-animation">
                        {{ $t("download_document") }}
                </a>
            </div>
            <form v-for="(field, index) in form.form_fields" v-bind:key="index">

                <div v-if="((index == form.currentField && form.completed == false) || (form.completed && field.form_field_questions[0].form_field_answers[0].type != 'text')) && field.show">
                    <b>{{ index + 1 }} / {{ form.form_fields.length }}&nbsp;&nbsp;&nbsp;{{ field.form_field_questions[0].title }}</b>
                    
                    <div v-if="field.form_field_questions[0].form_field_answers[0].type == 'radio'">
                        <app-input  class="col-sm-12 pt-2" 
                                    :class="form.completed ? 'disabled' : ''" 
                                    type="radio" 
                                    :list="field.form_field_questions[0].form_field_answers" 
                                    v-model="field.answeredId" />
                    </div>
                    <div v-else-if="field.form_field_questions[0].form_field_answers[0].type == 'text'">
                        <div v-for="(answer, index) in field.form_field_questions[0].form_field_answers">
                            <div v-if="answer.show">
                                {{ answer.value }}
                                <app-input  class="col-sm-12 p-0 pt-2"
                                            :class="form.completed ? 'disabled' : ''" 
                                            type="textarea"
                                            v-model="field.answeredText"
                                            :placeholder="$t('text_type_input')" />
                            </div>
                        </div>
                    </div>

                    <div v-if="form.completed" class="note note-info">
                        <div>
                            <div class="questionnaire-mark" :class="field.answeredId == getCorrectAnswerId(field.form_field_questions[0].form_field_answers) ? 'questionnaire-mark-perfect' : 'questionnaire-mark-wrong'"></div>
                            <div v-if="field.answeredId == getCorrectAnswerId(field.form_field_questions[0].form_field_answers)">
                                {{ $t("correct") }}
                            </div>
                            <div v-else>
                                {{ $t("correct_answer_is") }}
                                {{ getCorrectAnswer(field.form_field_questions[0].form_field_answers) }}
                            </div>
                        </div>
                    </div>
                    <br />
                    <div v-if="form.form_fields[index + 1] && form.completed == false" class="text-center w-100">
                        <button class="btn btn-transparent" v-if="form.currentField != 0" @click.prevent="previousQuestion()">
                            {{ $t("back") }}
                        </button>
                        <button
                            type="submit"
                            class="btn"
                            :class="field.answeredId || field.answeredText ? 'btn-primary btn-pulse-animation' : 'btn-transparent disabled'"
                            @click.prevent="
                                selectAnswer(form.id, field.id, field.answeredId, field.form_field_questions[0].form_field_answers[0].type);
                                form.currentField++;
                            ">
                            {{ $t("send_answer") }}
                        </button>
                    </div>
                    <div v-else-if="form.completed == false" class="text-center w-100">
                        <button class="btn btn-transparent" v-if="form.currentField != 0" @click.prevent="previousQuestion()">
                            {{ $t("back") }}
                        </button>
                        <button
                            type="submit"
                            class="btn"
                            :class="field.answeredId || field.answeredText ? 'btn-primary btn-pulse-animation' : 'btn-transparent disabled'"
                            @click.prevent="
                                selectAnswer(form.id, field.id, field.answeredId, field.form_field_questions[0].form_field_answers[0].type);
                                submitForm(form.id, form.category);
                            ">
                            {{ $t("finish_and_send") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import AppLibrary from "../../../../../Helpers/AppLibrary";
export default {
    name: "AddResult",
    extends: AppLibrary,
    props: {
        candidateId: {
            type: String,
            default: 1,
        },
        currentTimelineStateId: {
            type: Number,
            default: 1,
        },
        timelineStateName: {
            type: [Object, String],
        },
        eventDate: {
            type: String,
        },
        form: {
            type: Object,
        },
    },
    watch: {
        rows: {
            immediate: true,
            deep: true,
            handler(val, oldVal) {
                if (oldVal) {
                    this.$emit("getFormData", JSON.stringify(val));
                }
            },
        },
    },
    computed: {
        documentContent() {
            if (this.form.document_content) {
                return this.form.document_content.replace(/\{[^}]+\}/g, '.........');
            } else {
                return '';
            }   
        },
    },
    data() {
        return {
            enabled: true,
            inputs: {
                form: [],
            },
            deadline: "",
            deadlineTo: "",
            deadlineFrom: "",
            deadlineEnd: "",
            deadlineDay: 0, // Delay
        };
    },
    created() {
        this.unwatchIsEventDateProp = this.$watch("eventDate", (newVal) => {
            if (newVal) {
                this.getDeadline();
                this.unwatchIsEventDateProp();
            }
        });
    },
    mounted() {
        let _this = this;

        setTimeout(function() {
            _this.getDeadline();
        }, 200);
    },
    methods: {
        /**
         * Select answer and prepare to be sent in bulk after answering all questions
         */
        getCorrectAnswerId(formFieldAnswers){
            let answer = formFieldAnswers.find(answer => answer.correct === 1);
            return answer.id;
        },
        getCorrectAnswer(formFieldAnswers){
            let answer = formFieldAnswers.find(answer => answer.correct === 1);
            return answer.value;
        },
        previousQuestion(){
            let currentField = this.form.currentField;
            this.form.currentField = parseInt(currentField)-1;
        },
        selectAnswer(formId, fieldId, answerId, answerType) {console.log("answerId"+answerId);
            let selectedField = this.form.form_fields.findIndex((field) => field.id == fieldId);console.log(selectedField);
            let selectedAnswer = this.form.form_fields[selectedField].form_field_questions[0].form_field_answers.findIndex((answer) => answer.id == answerId);
            let answerText = answerType == 'radio' ? this.form.form_fields[selectedField].form_field_questions[0].form_field_answers[selectedAnswer].value : this.form.form_fields[selectedField].answeredText;
            let answer = {
                form_id: formId,
                candidate_id: parseInt(this.candidateId),
                form_field_id: parseInt(fieldId),
                form_field_answer_id: parseInt(answerId),
                answer_text: answerText,
                deadline_day: this.deadlineDay,
            };

            // Add to existing array of answers or update answer
            let alreadyAnwseredField = this.inputs.form.some(field => field.form_field_id === parseInt(fieldId));

            if(alreadyAnwseredField){
                let currentField = this.inputs.form.findIndex(field => field.form_field_id === parseInt(fieldId));
                this.inputs.form[currentField] = answer; console.log("AA"+alreadyAnwseredField);
            } else {
                this.inputs.form.push(answer); console.log("BB"+alreadyAnwseredField);
            }
            
        },
        getResults(formId) {
            this.form.completed = true;

            // Hurray completed effect
            setTimeout(function() {
                document.querySelectorAll(".confetti").forEach((el) => (el.style.opacity = "0"));
            }, 2500);
            setTimeout(function() {
                document.querySelectorAll(".confetti").forEach((el) => (el.style.display = "none"));
            }, 3500);
        },
        getDeadline() {
            if (this.eventDate) {
                if (this.form.timeline_state == 7) {
                    this.deadline = moment(this.eventDate)
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .subtract(1, "days")
                        .format("D. M.");
                    this.deadlineEnd = moment(this.eventDate).subtract(1, "days");
                } else if (this.form.timeline_state == 8) {
                    this.deadline = moment(this.eventDate).format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate).format("D. M.");
                    this.deadlineEnd = moment(this.eventDate);
                } else if (this.form.timeline_state == 9) {
                    this.deadline = moment(this.eventDate)
                        .add(7, "days")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .add(1, "days")
                        .format("D. M.");
                    this.deadlineTo = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(7, "days")
                        .format("D. M.");
                    this.deadlineEnd = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(7, "days");
                } else if (this.form.timeline_state == 10) {
                    this.deadline = moment(this.eventDate)
                        .add(1, "months")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .add(7, "days")
                        .format("D. M.");
                    this.deadlineTo = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(1, "months")
                        .format("D. M.");
                    this.deadlineEnd = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(1, "months");
                } else if (this.form.timeline_state == 11) {
                    this.deadline = moment(this.eventDate)
                        .add(2, "months")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .add(1, "months")
                        .format("D. M.");
                    this.deadlineTo = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(2, "months")
                        .format("D. M.");
                    this.deadlineEnd = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(2, "months");
                } else if (this.form.timeline_state == 12) {
                    this.deadline = moment(this.eventDate)
                        .add(3, "months")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .add(2, "months")
                        .format("D. M.");
                    this.deadlineTo = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(3, "months")
                        .format("D. M.");
                    this.deadlineEnd = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(3, "months");
                } else if (this.form.timeline_state == 13) {
                    this.deadline = moment(this.eventDate)
                        .add(6, "months")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .add(3, "months")
                        .format("D. M.");
                    this.deadlineEnd = moment(this.eventDate).add(6, "months");
                }

                // Count delay or days before end of deadline
                let today = moment(new Date());
                if(today && this.deadlineEnd){
                    this.deadlineDay = this.deadlineEnd.diff(today, "days");
                }
                
            }
        },

        /**
         * Store newly created resource
         */

        submitForm(formId, formCategory) {
            this.axiosPost({
                url: "admin/app/form-add-results",
                data: { answers: this.inputs.form, category: formCategory },
            })
                .then((response) => {
                    if (response.data.length !== 0) {
                        this.getResults(formId);
                    }
                })
                .catch(({ response }) => {})
                .finally(() => {});
        },
    },
};
</script>
